export function setResult(state, searched) {
  state.searched = searched
}